import { createApolloClient, gql, useKraxiQuery } from "@origin-digital/kraxi";
import { config } from "../../config";
import { lpgConfigs } from "./config";
import { LpgProfileAccountDetails } from "./graphql-types/LpgProfileAccountDetails";

export const lpgClient = createApolloClient(lpgConfigs[config.env]);

const lpgAccountDetailsQuery = gql`
  query LpgProfileAccountDetails {
    viewer {
      accounts {
        accountNumber
        services(statuses: [ACTIVE]) {
          ... on LpgService {
            primary
            address {
              formattedAddress
            }
          }
        }
        contact {
          firstName
          lastName
          dateOfBirth
          mobile
          landline
        }
        billing {
          type
          email
          postalAddress
        }
      }
    }
  }
`;

export const useLpgAccountDetails = () =>
  useKraxiQuery<LpgProfileAccountDetails>(lpgAccountDetailsQuery, {
    client: lpgClient,
  });
